// Общее для сборки готовых страниц и для запуска сайта поверх них (изменение seo).
// Без DOM и без Node: модуль импортируют и браузер, и пререндер.

// <script type="application/json" id="prerender-data">: данные запросов, с которыми страница
// нарисована, — каталог, документы. Браузер кладёт их в кэш запросов до гидратации.
export const PRERENDER_DATA_ID = "prerender-data";

// Строка в консоли, если разметка готовой страницы разошлась с первой отрисовкой в браузере.
// Её ищет сквозной тест e2e/seo.spec.ts.
export const HYDRATION_MISMATCH_PREFIX = "[prerender] hydration mismatch";

// Атрибут на <html>: Mini App запущен — готовую главную сайта прятать до отрисовки.
export const TELEGRAM_LAUNCH_ATTRIBUTE = "data-launch";
export const TELEGRAM_LAUNCH_VALUE = "telegram";
